import { Component } from '@angular/core';
import { ModalController,NavController, Platform, NavParams, ViewController } from 'ionic-angular';
import { datos } from '../../providers/datos';
import { Detalle } from '../detalle/detalle';
import moment from 'moment';


import { ViewChild, ElementRef, Sanitizer} from '@angular/core';



declare var cordova:any;
declare var document:any;
declare var window:any;
declare var jQuery:any;
declare var $:any;

@Component({
  selector: 'html_str',
  templateUrl: 'html.html',
})




export class html  {

  @ViewChild('dataContainer') dataContainer: ElementRef;


menu="hoy";
hora:any;
fecha:any;
item= {
"id":"",
"nombre":"",
"cantidad":1,
"valor":0,
"fecha":"",
"hora":"",
"img":"assets/images/servicios/manos.jpg",
"des":"sasasasasas"
};

 //str_html ='<h2 style="text-align:center">Tu especialista</h2> <div class="card"> <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Circle-icons-profile.svg/1024px-Circle-icons-profile.svg.png" alt="John" style="width:40%"> <h1>Marta Saltos</h1> <p class="title">Av Sucre y Rocafuerte</p> <p>Portoviejo Manabí</p> <div style="margin: 24px 0;"> <a href="#"><i class="fa fa-dribbble"></i></a> <a href="#"><i class="fa fa-twitter"></i></a> <a href="#"><i class="fa fa-linkedin"></i></a> <a href="#"><i class="fa fa-facebook"></i></a> </div> <p><a   href="tel:+593991609510" class="boton"></a></p> </div>';
  //str_html=' <div class="invoice-box"> <table cellpadding="0" cellspacing="0"> <tr class="top"> <td colspan="2"> <table> <tr> <td class="title"> <img src="assets/images/logo/2.png" style="width:100%; max-width:300px;"> </td> <td> Factura #: 0001<br> Fecha: ENERO 06-2019<br> </td> </tr> </table> </td> </tr> <tr class="information"> <td colspan="2"> <table> <tr> <td> Ocrenails.<br> Crystian Bravo<br> ventas@ocreapp.com </td> </tr> </table> </td> </tr> <tr class="heading"> <td> Metodo Pago </td> <td> EFECTIVO # </td> </tr> <tr class="details"> <td> Pagado </td> <td> </td> </tr> <tr class="heading"> <td> Item </td> <td> Valor </td> </tr> <tr class="item"> <td> Acrílicas Esculpidas </td> <td> $34.00 </td> </tr> <tr class="item"> <td> Manos </td> <td> $5.50 </td> </tr> <tr class="item last"> <td> Acrílicas con Extensión </td> <td> $24.00 </td> </tr> <tr class="total"> <td></td> <td> Total: $63.50 </td> </tr> </table> </div>';
 
 
  str_html='';
 
 
 titulo='OcreApp';


  constructor(   
   private sanitizer: Sanitizer,
   public viewCtrl: ViewController,
   public params: NavParams,
   private datos:datos,

    public modalCtrl: ModalController,
    public navParams: NavParams,
    public navCtrl: NavController,
    private elementRef: ElementRef



   ) {
 

    // this.dataContainer.nativeElement.innerHTML = this.str_html;
 
     let temp =   this.navParams.get('item');
     console.log(temp);
     if(temp.titulo){
      this.str_html= temp.html;
      this.titulo = temp.titulo;
     }
 
    // this.producto= this.params.get('producto');
    //  this.item= temp;
      
    //  console.log( temp);

  }


  loadData() {
    this.dataContainer.nativeElement.innerHTML = this.str_html;
}

ngOnInit(){
  this.loadData();  
}





  ionViewDidLoad() {
    // var _hora = moment(hora,'HH:mm').locale('es');
    // var actual = moment(moment().format('HH:mm:ss'),'HH:mm').locale('es');


    this.hora = String(moment().format('HH:mm'));
    this.fecha = String(moment().format('YYYY-MM-DD'));

    console.log(this.fecha);
    // let dif = _hora.diff(actual,'minutes');

    this.item.hora=String(this.hora);
    this.item.fecha=String(this.fecha);


  }


  detalle() {

    setTimeout(() => {
      this.cancel();
    }, 50);


    
    console.log("detalle");

  
    
      this.navCtrl.push(Detalle,{ });
      
   


    // let modal = this.modalCtrl.create(Detalle,{},{cssClass: "detalle"});
    // modal.onDidDismiss(data => {
  
    //   if (data.dato) {
        
    //      }
    //      console.log(JSON.stringify(data));
    //    });
    // modal.present();
  
  }




  add(){
    let fecha = new Date()
    var _hora = moment(this.item.hora,'HH:mm').locale('es');
    var actual = moment(moment().format('HH:mm:ss'),'HH:mm').locale('es');
    let dif = _hora.diff(actual,'minutes');

// SI LA CITA ES HOY
    if(this.menu=="hoy"){
      console.log("cita para hoy");
      // this.item.fecha=String(fecha);
         
      // SI ES HOY PERO NO ES SUPERIOR AL MINIMO D ESPERA
        if (dif < this.datos.config.min_dia) {
          console.log("fuera del reglamento");
          this.datos.Toast("¡Debe ser mayor a "+this.datos.config.min_dia+" minutos desde la hora actual! ",2000);
          
        }
        else { 
          this.datos.pedido.fecha = this.item.fecha;
          this.datos.pedido.hora = this.item.hora;
            this.cancel();

          // this.datos.pedido.items.push(this.item);
          //  this.detalle();
        }
      }
// SI LA CITA ES POSFECHA

 if(this.menu=="despues"){
      console.log("cita para despues");
      
      var fecha2 = moment(this.item.fecha);
      let dif_dias = fecha2.diff(this.fecha, 'days');
      console.log(dif_dias);
      if (dif_dias<1) {
        this.datos.Toast("¡Fecha no permitida!",2000);
        
      }
      else {
        // this.datos.pedido.items.push(this.item);
        // this.detalle();
        this.datos.pedido.fecha = this.item.fecha;
          this.datos.pedido.hora = this.item.hora;
            this.cancel();
        

      }

    }






  }

  dismiss(){
    this.viewCtrl.dismiss();

  }

cancel(){
  
    this.viewCtrl.dismiss({dato:0});

}





}


// WEBPACK FOOTER //
// ./src/pages/html/html.ts